export default __webpack_public_path__ + "static/media/avatar_lion3.6895107b.mp3";